<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column"></div>
                <div class="column is-3">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        v-if="!cantEdit || 
                            (
                                acertoDespesa.situacao==5 && 
                                +$store.state.user.usuario.id == acertoDespesa.idusuario
                            )
                        "
                        @click="
                            $router.push({
                                name: 'des-acerto-despesa-item-new',
                                params: {uuid: acertoDespesa.uuid},
                                query: ($route.query && $route.query.idmotivo) ? 
                                    {idmotivo:  $route.query.idmotivo} : {}
                            })"
                    >
                        {{ $t("adicionar") }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper" v-if="tabs.length != 0">
                <!-- TABS -->
                <ul class="nav nav-tabs mb-4">
                    <li 
                        v-for="(tab, i) in tabs"
                        :key="i"
                        :class="{ active: tabSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">
                            <span
                                v-if="tab.icone"
                                class="icon"
                                :style="{ color: tab.cor }"
                            >
                                <i :class="tab.icone.toLowerCase()" />
                            </span>
                            {{ cutString(tab.descricao , 16) }}
                        </a>
                    </li>
                </ul>
                <!-- CONJTO DE tabs - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            <span
                                v-if="tabs[tabSelecionada].icone"
                                class="icon"
                                :style="{ color: tabs[tabSelecionada].cor }"
                            >
                                <i
                                    :class="
                                        tabs[tabSelecionada].icone.toLowerCase()
                                    "
                                />
                            </span>
                            {{
                                cutString(tabs[tabSelecionada].descricao , 16)
                            }}
                        </span>
                        <i class="mdi mdi-chevron-down"></i>
                    </div>

                    <b-dropdown-item
                        :class="{ active: tabSelecionada == i }"
                        aria-role="listitem"
                        v-for="(tab, i) in tabs"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        <span
                            v-if="tab.icone"
                            class="icon"
                            :style="{ color: tab.cor }"
                        >
                            <i :class="tab.icone.toLowerCase()" />
                        </span>
                        {{ cutString(tab.descricao , 16) }}
                    </b-dropdown-item>
                </b-dropdown>

                <section class="registry-wrapper">
                    <empty-table-message v-if="motivosDespesaList.length == 0" />
                    <div v-for="(motivoDespesa, i) in motivosDespesaList" :key="i">
                        <keep-alive>
                            <DespesaList
                                v-if="showThisTab(tabs[tabSelecionada], motivoDespesa.descricao)"
                                :motivodespesa="motivoDespesa"
                                :acertoDespesa="acertoDespesa"
                                :despesas="motivoDespesa.acertoDespesaItemList"
                                @reload="carregarDespesas($event)"
                                :cantEdit="cantEdit"
                                :isSupervisor="isSupervisor"
                                @redirectMotivoReprovacao="redirectMotivoReprovacao"
                            />
                        </keep-alive>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import AcertoDespesaItemService from "@/services/despesas/AcertoDespesaItemService";
import DespesaList from "@/components/despesas/acerto-despesa/abas/despesas/AcertoDespesaItemList.vue";

export default {
    components: {
        DespesaList,
    },
    props: {
        acertoDespesa: null,
        rotaAninhada: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: true,
        },
        isSupervisor: {
            type: Boolean,
            default: true,
        },
        parametrizacao: null,
    },
    data() {
        return {
            tabs: [],
            tabSelecionada: null,
            serviceDespesa: new AcertoDespesaItemService(this.$http, this.$router),

            valorTotalDespesas: 0,
            valorTotalDespesasDebita_acerto: 0,
            motivosDespesaList: [],
            aprovacaoParcial: 0,
        };
    },
    created() {
        this.carregarDespesas(this.$route.query.idmotivo ? this.$route.query.idmotivo : 0);
    },
    watch: {
        rotaAninhada(val) {
            if(!val) this.carregarDespesas(this.$route.query.idmotivo ? this.$route.query.idmotivo : 0);
        },
        valorTotalDespesas(val) {
            this.$emit('valorTotalDespesas', val);
        },
        valorTotalDespesasDebita_acerto(val) {
            this.$emit('valorTotalDespesasDebita_acerto', val);
        },
        aprovacaoParcial(val) {
            this.$emit('aprovacaoParcial', val);
        }
    },
    methods: {
        showThisTab(tab, table) {
            return (String(tab.descricao).toLowerCase() == String(table).toLowerCase());
        },
        changeTab(i) {
            this.tabSelecionada = i;
            // muda a query
            if (this.$route.query) {
                let query = {...this.$route.query};
                query.idmotivo = this.tabs[i].id;
                this.$router.replace({'query': query});
            } else {
                this.$router.push({ idmotivo: this.tabs[i].id })
                    .catch((error) => {
                        if (
                            error.name !== 'NavigationDuplicated' &&
                            !error.message.includes('Avoided redundant navigation to current location')
                        ) console.log(error);
                    });
            }
        },
        buildTabs(idmotivo) {
            this.tabs = [];
            let keepTab = false;
            //Crias as tabs que o colaborador possui despesas
            this.motivosDespesaList.forEach((motivo) => {
                if (motivo.acertoDespesaItemList.length > 0) {
                    this.tabs.push({
                        id: motivo.id,
                        descricao: motivo.descricao,
                        icone: motivo.icone,
                        cor: motivo.cor
                    });
                    if(idmotivo == motivo.id) keepTab = true;
                }
            });
            
            if(keepTab) {
                this.tabSelecionada = this.tabs.findIndex(fi => fi.id == idmotivo);
            } else if (this.tabs.length > 0) {
                if(this.$route.query && !this.isNull(this.$route.query.idmotivo)) {
                    let query = {...this.$route.query};
                    query.idmotivo = this.tabs[0].id;
                    this.$router.replace({'query': query});
                }
                this.tabSelecionada = 0;
            }
        },
        carregarDespesas(idmotivo = 0) {
            this.isLoading = true;
            this.serviceDespesa
                .findAllDespesasByAcerto(this.acertoDespesa.uuid)
                .then((r) => {
                    this.motivosDespesaList = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar os acertos: " + e);
                })
                .finally((r) => {
                    this.isLoading = false;
                    this.somarValorTotalDespesas();

                    this.buildTabs(idmotivo);
                });
        },
        somarValorTotalDespesas() {
            this.valorTotalDespesas = 0;
            this.valorTotalDespesasDebita_acerto = 0;

            this.motivosDespesaList.forEach((motivo) => {
                motivo.acertoDespesaItemList.forEach((despesa) => {
                    if(despesa.situacao > 0) {
                        this.valorTotalDespesas += despesa.valordespesa;

                        if(
                            this.isNull(despesa.desFormapagto) || 
                            !despesa.desFormapagto.debita_acerto
                        ) {
                            this.valorTotalDespesasDebita_acerto += despesa.valordespesa;
                        }

                    } else {
                        this.aprovacaoParcial = 1;
                    }
                });
            });
        },
        redirectMotivoReprovacao() {
            setTimeout(() => {
                this.$router.push({
                    name: 'des-motivo-new',
                    query: { id: this.acertoDespesa.id, tela: 'despesas' },
                });
            }, 500);
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
    .nav.nav-tabs {
        margin-bottom: 20px;
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: "";
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }

    @media only screen and (max-width: 760px) {
        .nav.nav-tabs-main {
            display: flex;
            justify-content: center;
            padding: 0;
            margin: 0;

            &::after {
                display: none;
            }
        }
        .nav.nav-tabs.nav-tabs-children {
            display: none;
        }
    }

    @media only screen and (min-width: 761px) {
        .mobile-tab-list {
            display: none;
        }
    }

}
</style>

